import { News } from './types';
import SwiperOverflowHidden from '../Swiper/SwiperOverflowHidden';
import NewsBannerItem from '@/components/News/NewsBannerItem';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation, Scrollbar, A11y]);
const SwiperCustom = styled(SwiperOverflowHidden)`
  padding: 0;
  overflow: hidden;
  .swiper-container {
    margin: 0 -16px;
  }

  .swiper-slide {
    overflow: hidden;
    width: 25%;
    padding: 0 16px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    z-index: 10;
  }

  ${breakpoint(`tablet`)} {
    .swiper-container {
      margin: 0 -13px;
    }

    .swiper-slide {
      width: 33.33%;
      padding: 0 13px;
    }
    .swiper-scrollbar {
      left: 13px;
    }
  }

  ${breakpoint(`mobile`)} {
    .swiper-slide {
      width: 50%;
    }
  }
`;

interface NewsListProps {
  banners: News[];
  basePath?: string;
}

const NewsBannerList: React.FC<NewsListProps> = ({
  basePath = ``,
  banners,
}) => (
  <>
    <SwiperCustom>
      <Swiper slidesPerView={1} navigation scrollbar={{ draggable: true }}>
        {banners.map((item) => (
          <SwiperSlide key={item.boardIndexNumber}>
            <NewsBannerItem
              basePath={basePath}
              banner={item}
              key={item.boardIndexNumber}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </SwiperCustom>
  </>
);
export default NewsBannerList;
